const index = {
    init: () => {
        $('.benefits-list .item').on('mouseenter', function() {
            const $this = $(this);
            const id = $this.data('id');
            if($this.hasClass('active')) return;
            $('.benefits-list .item').removeClass('active');
            $this.addClass('active');

            $('.benefits-header .large-text').removeClass('benefits-header-text-vis ');
            $(`.benefits-header .large-text[data-id="${id}"]`).addClass('benefits-header-text-vis');
        });
    }
}


index.init();